import React, { Component } from 'react';
import { Button, Modal } from 'antd';
import SvgIcon from 'SvgIcon';
import _ from 'lodash';
export default class BatchMsg extends Component {
  constructor (props) {
    super(props);

    this.state = {
      radioValue: 0,
      codeField: props.codeField || 'code',
      dataStr: '条数据'
    };
  }

  getTrimedMsgObjArr () {
    const trimedMsgArr = [];
    const msgObj = {
      trimedMsgArr,
      count: 0,
      sucessCount: 0,
      failCount: 0,
      ingCount: 0
    }
    // this.props.type
    // 1 生单工作台
    // 2 列表单据的批量操作，统一返回接口格式
    // 3 其他批量提示信息，比如业务组需要批量提示
    if (this.props.type == 1) {
      this.props.msgArr.map((obj, index) => {
        let control = null;
        if (obj.isComplete == true)
          control = { stateNum: 1, title: obj.name, info: obj.cacheData && obj.cacheData[this.state.codeField] }
        else if (obj.errInfo)
          control = { stateNum: 0, title: obj.name, info: obj.errInfo.message }
        else
          control = { stateNum: -1, title: obj.name, info: '保存中~' }
        trimedMsgArr.push(control);
      });
      msgObj.count = trimedMsgArr.length;
      msgObj.sucessCount = _.filter(trimedMsgArr, function (o) { return o.stateNum == 1 }).length;
      msgObj.failCount = _.filter(trimedMsgArr, function (o) { return o.stateNum == 0 }).length;
      msgObj.ingCount = _.filter(trimedMsgArr, function (o) { return o.stateNum == -1 }).length;
    }
    else if (this.props.type == 2) {
      const res = this.props.res;
      res.messages && res.messages.map((obj, index) => {
        trimedMsgArr.push({ stateNum: 0, title: '', info: obj });
      });
      msgObj.count = res.count;
      msgObj.sucessCount = res.sucessCount;
      msgObj.failCount = res.failCount;
      msgObj.ingCount = 0;
    }
    else if (this.props.type == 3) {
      msgObj.trimedMsgArr = this.props.msgArr;
      msgObj.count = msgObj.trimedMsgArr.length;
      msgObj.dataStr = this.props.dataStr;
      msgObj.sucessCount = _.filter(msgObj.trimedMsgArr, function (o) { return o.stateNum == 1 }).length;
      msgObj.failCount = _.filter(msgObj.trimedMsgArr, function (o) { return o.stateNum == 0 }).length;
      msgObj.ingCount = _.filter(msgObj.trimedMsgArr, function (o) { return o.stateNum == -1 }).length;
    }

    return msgObj;
  }

  getModalContent = () => {
    const msgObj = this.getTrimedMsgObjArr();
    const trimedMsgArr = msgObj.trimedMsgArr;
    this.numOK = _.filter(trimedMsgArr, function (o) { return o.stateNum == 1 }).length;
    this.numFail = _.filter(trimedMsgArr, function (o) { return o.stateNum == 0 }).length;

    if (this.numFail == 0 && this.props.type != 1) {
      return <div className='batchMsg-container'>
        <SvgIcon className={'icon-chenggongtishi'} type={'chenggongtishi'} />
        <div className='batchMsg-OK1'>操作成功!</div>
        <div className='batchMsg-OK2'>操作全部成功共<span>{msgObj.sucessCount}</span>{msgObj.dataStr || '条'}!</div>
        {
          this.bCanClose() ?
            <div className='batchMsg-OK'>
              <Button type='primary' onClick={this.handleOk}>知道了</Button>
            </div> : null
        }
      </div>;
    }
    else {
      const bShowRadio = this.numOK > 0 && this.numFail > 0;
      // let radioValue = this.state.userChoseRadio >= 0 ? this.state.userChoseRadio : 0;
      const radioValue = this.state.radioValue;
      let bShowFail = true;// 显示成功信息还是失败信息
      if (radioValue == 1 || this.numFail == 0) {
        bShowFail = false;
      }

      const controls = [];
      trimedMsgArr.map((obj, index) => {
        let control = null;
        if (bShowFail == true && obj.stateNum == 0) {
          control = (
            <div className='batchMsg-row'>
              <SvgIcon className={'icon-yibohui'} type={'yibohui'} />
              <div className='batchMsg-info'>
                {obj.title ? <span className='batchMsg-title'>{obj.title}</span> : ''}
                {obj.title ? <span>{'('}</span> : ''}
                <span className='batchMsg-errinfo'>{obj.info}</span>
                {obj.title ? <span>{')'}</span> : ''}
              </div>
            </div>
          );
        }
        else if (bShowFail == false && obj.stateNum == 1) {
          control = (
            <div className='batchMsg-row'>
              <SvgIcon className={'icon-yishenhe'} type={'yishenhe'} />
              <div className='batchMsg-info'>
                {obj.title ? <span className='batchMsg-title'>{obj.title}</span> : ''}
                {obj.title ? <span>{'('}</span> : ''}
                <span className='batchMsg-successinfo'>{obj.info}</span>
                {obj.title ? <span>{')'}</span> : ''}
              </div>
            </div>
          );
        }
        controls.push(control);
      });
      return (
        <div className='batchMsg-container'>
          <div className='batchMsg-suminfo'>共处理<span className='batchMsg-NumAll'>{msgObj.count}</span>{msgObj.dataStr || this.state.dataStr}，成功<span className='batchMsg-NumOK'>{msgObj.sucessCount}</span>{msgObj.dataStr || this.state.dataStr}，失败<span className='batchMsg-NumFail'>{msgObj.failCount}</span>{msgObj.dataStr || this.state.dataStr}。
            {bShowRadio ?
              <span className='batchMsg-Radios'>
                <span
                  className={'batchMsg-Radio-0 batchMsg-Radio-' + (radioValue == 0 ? 'Sel' : 'NoSel')}
                  onClick={() => this.setState({ radioValue: 0 })}
                >
                  失败信息
                </span>
                <span
                  className={'batchMsg-Radio-1 batchMsg-Radio-' + (radioValue == 1 ? 'Sel' : 'NoSel')}
                  onClick={() => this.setState({ radioValue: 1 })}
                >
                  成功信息
                </span>
              </span> : ''
            }
          </div>
          <div className='batchMsg-rows'>{controls}</div>
          {
            this.bCanClose() ?
              <div className='batchMsg-OK'>
                <Button type='primary' onClick={this.handleOk}>确定</Button>
                {
                  this.props.handleCancel ? <Button onClick={this.handleCancel}>取消</Button> : null
                }
              </div> : null
          }
        </div>
      );
    }
  }

  render () {
    const modalControl = this.getModalContent();
    if (this.props.type == 1 && this.props.visible == false)
      return <div />;
    else
      return <Modal
        title={(this.numFail == 0 && this.props.type != 1) ? '' : '批量操作'}
        visible={true}
        footer={null}
        maskClosable={process.env.__THEMETYPE__ !== 'ncc'}
        onClose={this.handleOk}
        className={(this.numFail == 0 && this.props.type != 1) ? 'batchMsg-Modal-OK' : 'batchMsg-Modal'}
      >
        <div className='batchMsg-Outer'>{modalControl}</div>
      </Modal>;
  }

  handleCancel = () => {
    if (this.props.handleCancel) {
      this.props.handleCancel();
    }
    if (this.props.close) {
      this.props.close();
    }
  }

  handleOk = () => {
    if (this.props.type == 1) {
      if (this.bCanClose() && this.props.handleOk) {
        if(this.props.close)
          this.props.close();
        else
          this.props.handleOk();
      }
    }
    else if (this.props.type == 2) {
      if (this.props.close) {
        this.props.close();
      }
    }
    else if (this.props.type == 3) {
      if (this.props.handleOk) {
        this.props.handleOk();
      }
      if (this.props.close) {
        this.props.close();
      }
    }
  }
  bCanClose = () => {
    if (this.props.hasOwnProperty('bCanClose')) {
      return this.props.bCanClose;
    }
    else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/batchMsg.jsx